import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import classNames from 'classnames'
import * as css from './option-selector.scss'
import Tappable from 'react-tappable'

// Currently works as a radio button group (where only one can be selected at a time)
class OptionSelector extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string,
        disabled: PropTypes.bool,
      })
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    labelDecorator: PropTypes.func,
  }

  render() {
    let { labelDecorator, options, name, className, value } = this.props

    return (
      <div
        role="radiogroup"
        aria-label={`${name} options`}
        className={classNames(css.optionsContainer, className)}
      >
        <input type="hidden" name={name} value={value} />
        {map(options, (option, idx) => (
          <Option
            key={idx}
            onClick={this.handleClick.bind(this)}
            value={option.value}
            label={
              labelDecorator
                ? labelDecorator(option.label || option.value)
                : option.label || option.value
            }
            disabled={option.disabled}
            selected={value == option.value}
          />
        ))}
      </div>
    )
  }

  handleClick(nextValue) {
    if (nextValue != this.props.value) {
      this.props.onChange(nextValue)
    }
  }
}

const Option = ({ value, label, onClick, selected, disabled }) => (
  <Tappable
    role="radio"
    component="button"
    aria-label={value}
    aria-checked={selected}
    tabIndex={selected ? 0 : -1}
    onClick={onClick.bind(null, value)}
    className={classNames(
      'btn btn-info btn-empty',
      css.option,
      { [css.selected]: selected },
      { [css.disabled]: disabled }
    )}
  >
    {label}
  </Tappable>
)

Option.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
}

export default OptionSelector
